import { useSyncExternalStore } from 'react'

/**
 * GLOBAL TIMEZONE FILTER (Lee, 23 Sep 2026) — clicking a clock on the wall
 * strip filters every applicable CRM list (Board, Leads) down to leads in
 * that clock's zone group. Tiny module-level store so the strip (mounted in
 * Layout) and the pages share state without threading props; survives route
 * changes, cleared by clicking the selected clock again.
 */
export interface TzFilter {
  /** The group's UTC offset (its identity on the strip). */
  off: number
  /** Every IANA zone collapsed into this clock. */
  zones: string[]
  /** Display label for "filtering by …" chips. */
  label: string
}

let current: TzFilter | null = null
const subs = new Set<() => void>()

export const setTzFilter = (f: TzFilter | null) => {
  current = f
  subs.forEach((s) => s())
}

export const toggleTzFilter = (f: TzFilter) => setTzFilter(current && current.off === f.off ? null : f)

export const useTzFilter = (): TzFilter | null =>
  useSyncExternalStore((cb) => { subs.add(cb); return () => subs.delete(cb) }, () => current)

/** Does a lead's zone pass the active filter? No filter = everything passes. */
export const matchesTzFilter = (f: TzFilter | null, tz?: string | null): boolean =>
  !f || (!!tz && f.zones.includes(tz))
